import CountryPageRenderer from '../components/CountryPageRenderer';
import icelandData from '../data/country-pages/iceland';

export default function IcelandCountryPage() {
  return <CountryPageRenderer data={icelandData} />;
}
